export const loadMarker = (marker, map, defaultLatitude, defaultLongitude) => {
  const latlngs = [];
  // Get latlng from first marker
  latlngs.push(marker.getLatLng());

  // eslint-disable-next-line new-cap
  const featureGroup = new L.featureGroup();
  marker.setLatLng(new L.LatLng(defaultLatitude, defaultLongitude), {
    draggable: "true",
  });

  featureGroup.addLayer(marker);

  featureGroup.addTo(map);
  map.fitBounds(featureGroup.getBounds());
};

export const initMap = (defaultLatitude, defaultLongitude, setPosition) => {
  // let marker;
  let map;
  if (map !== undefined) {
    map.remove();
  }
  L.mapbox.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

  const container = L.DomUtil.get("map");
  if (container != null) {
    container._leaflet_id = null;
  }

  map = L.mapbox
    .map("map")
    .setView([defaultLatitude, defaultLongitude], 8)
    .addLayer(L.mapbox.styleLayer(process.env.REACT_APP_MAPBOX_STYLE_ID));

  const marker = L.marker([defaultLatitude, defaultLongitude], {
    draggable: "true",
  });

  setTimeout(() => {
    loadMarker(marker, map, defaultLatitude, defaultLongitude);
  });

  marker.on("dragend", function (event) {
    let marker = event.target;
    let position = marker.getLatLng();
    marker.setLatLng(new L.LatLng(position.lat, position.lng), {
      draggable: "true",
    });
    map.panTo(new L.LatLng(position.lat, position.lng));
    setPosition(position);
  });
};
